import {
  SignInResponseDto,
  SignInResponseDtoError,
  SignInResponseDtoResult,
} from "../models";

export const isErrorDto = (
  data: SignInResponseDto,
): data is SignInResponseDtoError => {
  return SignInResponseDtoError.safeParse(data).success;
};

export const isSuccessDto = (
  data: SignInResponseDto,
): data is SignInResponseDtoResult => {
  return SignInResponseDtoResult.safeParse(data).success;
};
